const triggerAnchorDownload = (url: string, filename: string): void => {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.rel = "noopener noreferrer";
  link.referrerPolicy = "no-referrer";
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export async function downloadFileFromUrl(
  url: string,
  filename: string,
): Promise<void> {
  const response = await fetch(url, {
    referrerPolicy: "no-referrer",
  });
  if (!response.ok) {
    throw new Error(`Download failed (${response.status})`);
  }

  const blob = await response.blob();
  const fileBlob = new Blob([blob], { type: "application/octet-stream" });
  const objectUrl = URL.createObjectURL(fileBlob);
  try {
    triggerAnchorDownload(objectUrl, filename);
  } finally {
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  }
}
